import React, { Component } from 'react';
import Routes from './routes/Routes';
import { Layout } from 'antd';

class App extends Component {
  render() {
    return (
      <Layout>
        <Routes />
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js